import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { adminMe } from './adminApi';

export default function ProtectedRoute({ children }) {
    const [status, setStatus] = useState('checking'); // checking | ok | denied
    useEffect(() => {
        const token = localStorage.getItem('admin_token');
        if (!token) { setStatus('denied'); return; }
        adminMe()
            .then(() => setStatus('ok'))
            .catch(() => setStatus('denied'));
    }, []);
    if (status === 'checking') {
        return <div className="min-h-screen flex items-center justify-center bg-[#FAFAF7] text-[#87847E]">Checking session...</div>;
    }
    if (status === 'denied') return <Navigate to="/admin/login" replace />;
    return children;
}
